import { render, staticRenderFns } from "./GoodNewsPresentation.vue?vue&type=template&id=da241e1c"
import script from "./GoodNewsPresentation.vue?vue&type=script&lang=js"
export * from "./GoodNewsPresentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports